import React from 'react';
import { ComponentsContext } from '../contexts/componentsContext';

export default function useComponentContext() {
  const ctx = React.useContext(ComponentsContext);
  return ctx;
}
